import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
export default function Seo() {
  const { pathname } = useLocation();
  const [meta,setMeta] = useState(null);
  useEffect(()=>{
    const controller=new AbortController();
    setMeta(null);
    if(['/answers','/advisory-admin'].includes(pathname)) return ()=>controller.abort();
    fetch('/api/seo?path='+encodeURIComponent(pathname),{signal:controller.signal})
      .then(r=>r.ok?r.json():null).then(setMeta).catch(()=>{});
    return ()=>controller.abort();
  },[pathname]);
  if(!meta)return null;
  return <Helmet>
    <title>{meta.title}</title><meta name="description" content={meta.description} />
    <link rel="canonical" href={meta.canonical} />
    <meta property="og:site_name" content="Simone Di Somma" /><meta property="og:locale" content="en_GB" />
    <meta property="og:title" content={meta.title} /><meta property="og:description" content={meta.description} />
    <meta property="og:url" content={meta.canonical} /><meta property="og:type" content={meta.article?'article':'website'} />
    <meta property="og:image" content={meta.image} /><meta property="og:image:width" content="1200" /><meta property="og:image:height" content="630" /><meta property="og:image:alt" content={meta.imageAlt} />
    <meta name="twitter:card" content="summary_large_image" /><meta name="twitter:title" content={meta.title} /><meta name="twitter:description" content={meta.description} /><meta name="twitter:image" content={meta.image} />
    {meta.published && <meta property="article:published_time" content={meta.published} />}
    <script type="application/ld+json">{JSON.stringify(meta.schema)}</script>
  </Helmet>;
}
